// src/components/JeddahBoardPack/pages/Page27AirportEnforcementProfileTable.jsx
import React, { useState, useEffect } from 'react';
import AirportEnforcementProfileTable from '../components/tables/AirportEnforcementProfileTable';
import LoadingComponent from '@/components/common/LoadingComponent';
import ErrorState from '@/components/common/ErrorStateComponent';
import { apiCall } from '@/api/apiCall';
import { useQueue } from '@/context/QueueContext';
import { jeddahFallbackData } from '../constant/jeddahFallbackData';


const getByKey = (apiData,  key) => {
  const found = apiData.find(t => t.table_key === key);
  if (found) return found; 
  return jeddahFallbackData.find(t => t.table_key === key); 
};
const Page27AirportEnforcementProfileTable = ({year = "",month = "",monthNumber = "",contract = "",page = null }) => {
    const { enqueue } = useQueue();

  const [enforcementData, setEnforcementData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [apiParams] = useState({
    contract: contract,
    year: year,
    month: monthNumber,
  });

  // Fetch data from API
  useEffect(() => {
    const fetchEnforcementData = async () => {
      try {
        setLoading(true);
        setError(null);
        setEnforcementData(null);

        const response = await enqueue(() => apiCall(
          "GET",
          "/boardpack/get-tables-data",
           {
            year: year,
            contract: "Jeddah Airport Contract",
            month: monthNumber,
          }
        ));

        if (!response?.success) {
          throw new Error(response?.message || "API returned unsuccessful response");
        }
          let data = response?.data
        if (!Array.isArray(response?.data) || response.data.length === 0) {
          data =  jeddahFallbackData
}

        // Transform API data to component format
        const transformedData = transformApiDataToComponentFormat(data);
        setEnforcementData(transformedData);

      } catch (err) {
        console.error("Error fetching enforcement data:", err);
        setError(err.message || "Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    fetchEnforcementData();
  }, [year, month, contract]);

  // Transform API response to the format expected by component
  const transformApiDataToComponentFormat = (apiData) => {
    // Find specific tables by table_key
    // const profileSummary = apiData.find(t => t.table_key === "jeddah_airport_enforcement_profile_summary")?.data || {};
    // const violationsTable = apiData.find(t => t.table_key === "violations_table_fees")?.data || {};
    // const assetsDeployedEnforcement = apiData.find(t => t.table_key === "assets_deployed_enforcement")?.data || {};
            const title = getByKey(apiData, "jeddah_airport_enforcement_profile_summary") || "";
            const profileSummary = getByKey(apiData, "jeddah_airport_enforcement_profile_summary")?.data || {};
            const violationsTable = getByKey(apiData, "violations_table_fees")?.data || {};
            const assetsDeployedEnforcement = getByKey(apiData, "assets_deployed_enforcement")?.data || {};
    

    return {
      profileName: title?.title || 'Jeddah Airport Enforcement Profile',
      section: profileSummary.section || 'Assets Deployed',
      
      // Transform violations table
      violations: {
        columns: violationsTable.columns || [],
        rows: violationsTable.rows || [],
        notes: violationsTable.notes?.items || []
      },

      // Transform assets deployed
      assetsDeployed: transformAssetsDeployed(assetsDeployedEnforcement.groups || []),
      
      // Store original API params for POST requests
      apiParams: apiParams
    };
  };

  // Transform assets deployed from API format to component format
  const transformAssetsDeployed = (groups) => {
    const result = [];
    
    groups.forEach(group => {
      // Add group header
      result.push({
        name: group.group,
        isCategory: true,
        subCount: '',
        totalCount: group.total !== undefined && group.total !== null ? String(group.total) : ''
      });

      // Add items under this group
      (group.items || []).forEach(item => {
        result.push({
          name: item.name,
          isCategory: false,
          subCount: item.qty !== null && item.qty !== undefined ? String(item.qty) : '-',
          totalCount: ''
        });
      });
    });

    return result;
  };

  if (loading) {
    return <LoadingComponent />;
  }

  if (error) {
    return <ErrorState error={error || "Something went wrong"} />;
  }

  return <AirportEnforcementProfileTable enforcementData={enforcementData} year={year} monthNumber={monthNumber} contract={contract} />;
};

export default Page27AirportEnforcementProfileTable;